module.exports = __webpack_public_path__ + "img/金属材料学7_3.752fd825.png";